export interface State {
  autoRedirect?: boolean;
  organisationId?: string;
  samlConnectionId?: string;
}

export const defaultState: State = {};

const orgLoginConfig = (state: State = defaultState): State => state;

export default orgLoginConfig;
